import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgCarService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
    ,FvmsExcelService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import { DtgManageCarExtMainFormComponent }
from "src/app/dtg/manage/car/ext/main/form/dtg.manage.car.ext.main.form.component";

@Component({
    selector: "dtg-manage-car-ext-main-list"
    ,templateUrl: './dtg.manage.car.ext.main.list.component.html'
    ,providers: []
})
export class DtgManageCarExtMainListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    listCar:any[];
    listTeam:any[];
    listCarType:any[];
    @Input() listType:DtgListType = DtgListType.list;
    @Output() carInfo = new EventEmitter();
    searchValue:string;
    dtgTeamId:string = "";
    dtgTeamNm:string;
    dtgCarType:string = "0";
    useYn:string = "";
    userGroupId:number;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
            });
     }

    ngOnInit() {
        this.reloadListItem();
        this.reloadListItemTeam();
        this.reloadListItemCarType();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    clickSearch(){
        this.reloadListItem();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem();
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,dtgCarType : this.dtgCarType
            ,searchValue : this.searchValue
            ,useYn : this.useYn
        };
        this.fvmsApiDtgCarService.getListCarExt(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listCar = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    // 셀렉트박스 차량종류
    reloadListItemCarType(){
        this.fvmsApiDtgCarService.getListCarType(null)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listCarType = apiResponse.resultValue;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    changeTeamInfo(event){
        this.reloadListItem();
    }

    changeCarType(event){
        this.reloadListItem();
    }

    changeUseYn(event){
        this.reloadListItem();
    }

    clickSelectCar(carInfo){
        this.carInfo.emit(carInfo);
    }

    clickOpenModalCarInfo(dtgActionType:DtgActionType,carInfo:any){
        let modalRef = this.modalService.open(
            DtgManageCarExtMainFormComponent
            ,{
                centered:true
                ,size: "lg"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = carInfo.companyId;
        modalRef.componentInstance.teamId = carInfo?.dtgTeamId;
        modalRef.componentInstance.dtgUnitId = carInfo.dtgUnitId;

        modalRef.result.then((resultModal) => {
            switch(dtgActionType){
                case DtgActionType.create:
                case DtgActionType.update:
                case DtgActionType.delete:
                    if(resultModal.result === "ok"){
                        this.clickSearch();
                    }
                    break;
                default:
                    break;
            }
        });
    }

    exportExcel(){

    }
}